module.exports = __webpack_public_path__ + "img/xcx.5f87932d.png";